import Icon from "../Icon";

interface PropsType {
    type: string;
    level: string | null;
    onAlertClick?: (type: string) => void;
    label: string;
    selected: boolean;
    active: boolean;
    disabled: boolean;
    icon?: string
}

const containerIconStyle: Record<string, string> = {
    justifyContent: "center",
    alignItems: "center",
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    boxShadow: "0px 4px 16px 0px rgba(189, 189, 189, 1)",
};

export default function WeatherObservationItem({type, level, label, selected, onAlertClick, disabled, active, icon}: PropsType): JSX.Element {
    const setBackgroundColor = (level: string | null, disabled: boolean, active: boolean, selected: boolean): string => {
        // if (!disabled && selected) {
        //     return "blue";
        // }
        if (!disabled && active) {
            return "red";
        }
        return "#cdcdcd";
    };

    return (
        <>
            <button
                className="IconButton"
                onClick={onAlertClick ? () => onAlertClick(type) : undefined}
                style={{backgroundColor: "transparent", border: "none"}}
                disabled={disabled}
            >
                <Icon
                    type={icon||type}
                    containerStyle={{
                        ...containerIconStyle,
                        backgroundColor: setBackgroundColor(level, disabled, active, selected),
                        cursor: active ? "pointer" : "auto",
                    }}
                />
            </button>
            <h5 style={{margin: ".5rem 0"}}>{label}</h5>
        </>
    );
}
